<template>
<p>برای یادبود فرزند آفتاب - آلبر کامو این <a href="https://github.com/Mehranalam/Albert-Camus">پروژه</a> کاملا متن باز است و تحت لیسانس GPL منتشر و نگهداری میشود</p>
</template>

<script>
export default {
    name: 'theFooter'
}
</script>

<style>
#jjop {
    margin-top: 30px;
}
</style>
